<template>
  <div class="text-start bg-white text-start ">
    <div class="font-semibold uppercase mb-4 text-gray-600">{{ title }}</div>

    <div class="my-3">
      <label class="">Customer Groups</label>
      <multiselect v-model="selectedGroups" placeholder="Customer Groups" :multiple="true"
                   track-by="id" :options="groups" label="name"
                   :taggable="true"/>
    </div>
    <div class="my-3 grid md:grid-cols-2 md:gap-4" style="z-index: 0">
      <div> 
        <label class="">Channel</label>
        <select class="input" v-model="channel">
          <option value="BOTH">SMS and Email</option>
          <option value="SMS">SMS Only</option>
          <option value="EMAIL">Email Only</option>
        </select>
      </div>
      <div class="">
        <label class="">Schedule At</label>
        <input class="input" v-model="dispatchAt" type="datetime-local">
      </div>
    </div>

    <div class="mt-6 text-right">
      <button type="submit" v-on:click="saveRecord"
              class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "ScheduleBlastComponent",
  components: {},
  data() {
    return {
      name: null,
      dispatchAt: null,
      channel: "BOTH",
      record: {},
      errors: [],
      groups: [],
      selectedGroups: [],
      inputClass: ''

    }
  },
  mounted() {
    GraphQl.sendRequest("{customerGroups{id name}}")
        .then(response => {
              this.groups = response.customerGroups;
            }
        )
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    title: {type: String, default: "Schedule Message dispatch"},
    id: {type: String, required: true}
  },
  methods: {
    removeFilter(i) {
      this.filters.profile.splice(i, 1)
    },
    addFilter() {
      this.filters.profile.push(Object.assign({}, this.filter))
    },
    saveRecord() {
      // scheduleBroadcast(id: String!,dispatchAt: String, channel: String  customerGroups: [String]): Response
      let ids = [];
      this.selectedGroups.forEach(item => {
        ids.push(item.id)
      })
      let params = 'id: "' + this.id + '", channel: "' + this.channel + '", customerGroups: ["' + ids.join(",") + '"]' +
          'dispatchAt: "' + this.dispatchAt + '"';

      GraphQl.sendRequest('mutation{scheduleBroadcast(' + params + '){code message recordId}}')
          .then(response => {
            this.$root.$emit(response.scheduleBroadcast.code === 200 ? 'alert_success' : 'alert_error', [response.scheduleBroadcast.message]);
            if (response.scheduleBroadcast.code === 200)
              this.$root.$emit("hide_modal");
          })
          .finally(() => {
            this.$root.$emit("refresh", 'schedules');
          })
    }
  }
}
</script>

<style>

.vue-daterange-picker {
  height: 100%;
}

input:checked + svg {
  display: block;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff !important;
  background-clip: padding-box;
  border: 1px solid #e8e8e8 !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.reportrange-text {
  width: 100%;
  /*height: 100%;*/
  padding: 10px 10px 8px 10px !important;
}

.vue-daterange-picker {
  width: 100%;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}


.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}


</style>